import {
  productItem,
  createItem,
  shareDesignItem,
  basketItem,
  productChangeItem,
  productColorItem,
  printStyleItem,
  productInfoItem,
  addTextItem,
  addUploadItem,
  addDesignItem
} from './navigation-items';

export default [
  {
    ...productItem,
    items: [
      productChangeItem,
      productColorItem,
      printStyleItem,
      productInfoItem
    ]
  },
  {
    ...createItem,
    items: [addTextItem, addUploadItem, addDesignItem, printStyleItem]
  },
  shareDesignItem,
  basketItem
];
